
export const userInputs = [
  {
    id: 1,
    label: "Username",
    type: "text",
    placeholder: "john_doe",
  },
  {
    id: 2,
    label: "Name and surname",
    type: "text",
    placeholder: "John Doe",
  },

  {
    id: 3,
    label: "Email",
    type: "mail",
    placeholder: "john_doe@gmail.com",
  },

  {
    id: 4,
    label: "Phone",
    type: "text",
    placeholder: "+234 8134 996 425",
  },

  {
    id: 5,
    label: "Password",
    type: "password",
  },

  {
    id: 6,
    label: "Address",
    type: "text",
    placeholder: "Money St. 100 Eko Lagos",
  },

  {
    id: 7,
    label: "Country",
    type: "text",
    placeholder: "Nigeria",
  },
];

export const roomInputs = [
  {
    id: 1,
    label: "Title",
    type: "text",
    placeholder: "Classic Room",
  },
  {
    id: 2,
    label: "Description",
    type: "text",
    placeholder: "Description",
  },
  {
    id: 3,
    label: "Facilities",
    type: "text",
    placeholder: "Gym",
  },

  {
    id: 4,
    label: "Price",
    type: "text",
    placeholder: "10000",
  },
  {
    id: 5,
    label: "Availability",
    type: "text",
    placeholder: "Available",
  },
];